export default class SliderController {
    constructor() {
        this.swiper = null;
        this.sliders = [];

        this.init();
    }

    init() {
        if (document.querySelectorAll('.swiper-container').length) {
            if (typeof Number.isNaN == 'undefined') {
                Number.isNaN = number => number === NaN;
            }

            import( /* webpackChunkName: "modules/slider" */ 'swiper').then(e => {
                this.swiper = e.Swiper;
                this.swiper.use([e.Navigation, e.Scrollbar, e.Pagination, e.Autoplay]);

                document.querySelectorAll('.swiper-container').forEach(container => {

                    let settings = {
                        spaceBetween: 40,
                        grabCursor: true,
                        threshold: 10,
                        // navigation: {
                        //     nextEl: container.parentElement.querySelector('.swiper-button-next'),
                        //     prevEl: container.parentElement.querySelector('.swiper-button-prev'),
                        // },
                        // scrollbar: {
                        //     el: container.parentElement.querySelector('.swiper-scrollbar'),
                        //     draggable: true,
                        //     hide: false,
                        // },
                        mousewheel: {
                            forceToAxis: true,
                        },
                        on: {},
                    };

                    if (container.parentElement.querySelector('.swiper-pagination')) {
                        if (container.querySelectorAll('.swiper-slide').length > 1) {
                            settings.pagination = {
                                el: container.parentElement.querySelector('.swiper-pagination'),
                                clickable: true,
                            };
                        } else {
                            container.parentElement.querySelector('.swiper-pagination').remove();
                        }
                    }

                    settings = Object.assign(settings, this.getSpecificOptions(container));

                    if (container.parentElement.querySelector('.indicator')) {
                        settings.on.sliderMove = () => {
                            container.parentElement.querySelector('.indicator').classList.add('hidden');
                        };
                    }

                    const slider = new this.swiper(container, settings);

                    this.sliders.push(slider);
                });
            });
        }
    }

    getSpecificOptions(container) {
        let settings = {
            breakpoints: {},
        };

        settings.breakpoints[app.breakpoints.xs.size] = {
            spaceBetween: app.breakpoints.xs.gutter,
            slidesPerView: 1,
        };

        settings.breakpoints[app.breakpoints.sm.size] = {
            spaceBetween: app.breakpoints.sm.gutter,
            slidesPerView: 1.2,
        };

        settings.breakpoints[app.breakpoints.md.size] = {
            spaceBetween: app.breakpoints.md.gutter,
            slidesPerView: 2,
        };

        settings.breakpoints[app.breakpoints.lg.size] = {
            spaceBetween: app.breakpoints.lg.gutter,
            slidesPerView: 2.5,
        };

        if (container.classList.contains('storySlider')) {
            settings.breakpoints = [];
            settings.spaceBetween = 0;
            settings.slidesPerView = 1;
            settings.autoplay = {
                delay: 10000
            };
            settings.navigation = {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              };
        }

        if (container.classList.contains('gallerySlider')) {
            settings.breakpoints = [];
            settings.spaceBetween = 20;
            settings.slidesPerView = 1.2;
            settings.autoplay = false;
            settings.navigation = {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              };
              settings.breakpoints[app.breakpoints.md.size] = {
                spaceBetween: 30,
                slidesPerView: 2.8,
            };
            settings.breakpoints[app.breakpoints.xl.size] = {
                spaceBetween: 30,
                slidesPerView: 3.7,
            };
        }


        if (container.classList.contains('updateSlider')) {
            settings.speed = 1000;
            settings.autoplay = false;
            settings.loop = false;
            settings.centeredSlides = false;
            settings.slidesPerView = 1.2;
            settings.slideToClickedSlide = false;
            settings.disableOnInteraction = true;
            settings.breakpoints[app.breakpoints.xs.size] = {
                spaceBetween: 20,
                slidesPerView: 1.2,
            };
            settings.breakpoints[app.breakpoints.sm.size] = {
                spaceBetween: 20,
                slidesPerView: 1.2,
            };
            settings.breakpoints[app.breakpoints.md.size] = {
                spaceBetween: 30,
                slidesPerView: 2.2,
            };
            settings.breakpoints[app.breakpoints.lg.size] = {
                spaceBetween: 30,
                slidesPerView: 2.75,
            };
            settings.breakpoints[app.breakpoints.xl.size] = {
                spaceBetween: 30,
                slidesPerView: 3.9,
            };
            settings.breakpoints[1920] = {
                spaceBetween: 30,
                slidesPerView: 4.2,
            };
            settings.navigation = {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              };
        };

        return settings;
    }
}